import ApiService from '../ApiService';
import { mapActions } from 'vuex';

const AuthService = {

    async login(identification, password) {
        try {
            return await ApiService.post('/auth/request-token', { identification, password })
        } catch (error) {
            throw error
        }
    },
    async loginApp(identification, password) {
        try {
            return await ApiService.get('/login-app', { identification, password })
        } catch (error) {
            throw error
        }
    },

    async loginToken(token) {
        try {
            return await ApiService.customRequest({
                url: process.env.VUE_APP_ROOT_API,
                method: 'post',
                data: { token },
                withCredentials: true
            })
        } catch (error) {
            throw error
        }
    },

    async loginToken2() {
        try {
            return await ApiService.customRequest({
                url: '/auth/login',
                method: 'post',
                withCredentials: true
            })
        } catch (error) {
            throw error
        }
    },

    async requestToken(data) {
        try {
            return await ApiService.post('/auth/request-token-new', { identification: data.identification, identificationType: data.identificationType })
        } catch (error) {
            throw error
        }
    },

    ...mapActions('auth', ['logout']),
    logOut() {
        this.logout
    }
}

export default AuthService;